// ChalkOS × Voluntold integration config.
// ChalkOS is a Voluntold coaching tool: operational software for running youth-sports teams.
// ONLY verified getchalkos.com capabilities are described here — no invented features.
// Practice/drill DESIGN is intentionally NOT a ChalkOS claim (that stays Voluntold's Practice Plan Generator).

export const CHALKOS_URL = "https://getchalkos.com";
export const CHALKOS_SIGNUP_URL = "https://getchalkos.com/login?mode=signup";

// Verified ChalkOS features (name + what it does), for the /chalkos page grid.
export const CHALKOS_FEATURES = [
  { name: "The Chalkboard", desc: "Your season at a glance — practices, games, and the next play in one view." },
  { name: "The Clipboard", desc: "What every family sees: tonight's plan, who's in, and what to bring." },
  { name: "Chalk Talk", desc: "One-tap announcements to the whole team, with read receipts so you know it landed." },
  { name: "The Playbook", desc: "Every game and practice on one conflict-aware timeline." },
  { name: "Erase & Redraw", desc: "Cancel, reschedule, and notify everyone in three taps." },
  { name: "Draw It Up", desc: "ChalkOS drafts the coach-voice update. You hit send." },
  { name: "Volunteer Management", desc: "Snack rotations and duties parents claim themselves." },
  { name: "Season Archive", desc: "Wrap a season in one tap and roll the roster into next year." },
];

// EXPLICIT allow-list of Strong-fit articles (reviewed + approved). ChalkOS is NEVER auto-attached
// to coach content — a slug must appear here, with copy tied to the article's operational problem.
const STRONG_FIT = {
  "coaches-corner-top-tips-every-first-time-coach-should-know": {
    context: "organization",
    headline: "The coaching part gets easier. The managing part buries first-timers.",
    body: "Rosters, schedules, and team messages don't have to live in five places. ChalkOS keeps them in one.",
  },
  "the-dugout-whiteboard-that-cuts-repeat-questions": {
    context: "communication",
    headline: "Answer it once — not twenty times.",
    body: "ChalkOS sends one update to every family with read receipts, so 'what time, where, what do we bring' stops flooding your phone.",
  },
  "the-clipboard-checklist-that-calms-game-day-chaos": {
    context: "game-day organization",
    headline: "Game day shouldn't start with a group-text scramble.",
    body: "The ChalkOS Clipboard shows every family the plan, the RSVPs, and what to bring — before anyone has to ask.",
  },
  "parent-sideline-series-preseason-checklist-to-prep-kids-for-sports": {
    context: "season setup",
    headline: "A season's easier to run when it's set up right.",
    body: "Build the roster, set the schedule, and invite every family in minutes with ChalkOS — then the season runs itself.",
  },
  "you-didnt-sign-up-you-got-voluntold-now-what": {
    context: "organization",
    headline: "You got voluntold. ChalkOS was built for exactly this.",
    body: "Schedule, roster, and team messages in one place — so the job you didn't ask for doesn't eat your week.",
  },
  "coaching-tips-for-rookie-coaches-from-someone-whos-been-there": {
    context: "organization",
    headline: "The clipboard stuff nobody warns rookies about.",
    body: "ChalkOS handles the schedule, the roster, and the team updates so your energy goes into actually coaching.",
  },
  "parent-sideline-series-ultimate-guide-to-being-the-best-team-mom": {
    context: "volunteers & communication",
    headline: "The team-mom job is really team logistics.",
    body: "Volunteer sign-ups, snack rotation, and one-tap updates to every family — ChalkOS handles the moving parts so you don't live in the group chat.",
  },
};

// Returns { relevance: 'strong'|'none', context?, headline?, body? }.
export function pickChalkosContext(article) {
  const m = article && STRONG_FIT[article.slug];
  return m ? { relevance: "strong", ...m } : { relevance: "none" };
}
